import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { useLocation, Link } from 'react-router-dom'
import { Table } from 'rsuite'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import {
  getChildSuppliersCount,
  getMasterSuppliersCount,
  getGlobalAcceptingSuppliersCount,
  getUnassignedChildSuppliersCount,
  getSuppliersInQaCount,
  getCardableMastersCount,
  getSuppliersWithoutCardAcceptanceCount,
  getTopCardableSuppliers,
  getTopOpportunitiesWithUnknownAcceptance,
  getTopOpportunitiesWithNoAcceptance,
  getSuppliersAddedByPerUser,
  getSuppliersInSequenceCount,
  getAllSuppliersData
} from '../../redux/actions/vendor'
import { getRecentlyViewedSearchData, getRecentKeywords } from '../../redux/actions/user'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { AppContext } from '../../context';
import { getAllNotification } from '../../redux/actions/notification';

ChartJS.register(ArcElement, Tooltip, Legend)
const { Column, HeaderCell, Cell } = Table

const tableColumns = [
  { name: 'suppliername', label: 'Supplier Name' },
  { name: 'potentialcv', label: 'Potential CV' },
  { name: 'totalsuppliers', label: 'Total Suppliers' },
]

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} className="table-link text-black">
      {dataKey === 'suppliername' ?
        <Link className='text-black text-decoration-none' to={{ pathname: `/suppliers/${rowData.masterId}` }} target="_blank" >
          {rowData[dataKey]}
        </Link>
        :
        rowData[dataKey] ? Number(rowData[dataKey]).toLocaleString() : rowData[dataKey]
      }
    </Cell>
  )
}

const DashboardComponent = () => {
  const store = useStore().getState()
  const location = useLocation()
  const dispatch = useDispatch()
  const { app, user } = store
  const { sideMenus } = app
  const { domainUsers } = user

  const {
    getNewUnreadNotification
  } = useContext(AppContext);

  const currentPageName = sideMenus && sideMenus.find(menu => location.pathname.includes(menu.name))?.label
  const domainUserIds = domainUsers.map(user => { return user.userId })

  const state = {
    datasets: [
      {
        data: [],
        backgroundColor: [
          '#214466',
          '#32B83F',
          '#65B3E9',
          '#D9D9D9',
        ],
      },
    ],
  }

  const [totalChildRecords, setTotalChildRecords] = useState({ count: 0, last30DaysCount: 0 })
  const [totalMasterRecords, setTotalMasterRecords] = useState({ count: 0, last30DaysCount: 0 })
  const [totalGlobalAcceptingSuppliers, setTotalGlobalAcceptingSuppliers] = useState({ count: 0, last30DaysCount: 0 })
  const [totalUnassignedChildRecords, setTotalUnassignedChildRecords] = useState({ count: 0, last30DaysCount: 0 })
  const [totalSuppliersInQaRecords, setTotalSuppliersInQaRecords] = useState({ count: 0, last30DaysCount: 0 })
  const [totalSuppliersWithoutCardAccRecords, setTotalSuppliersWithoutCardAccRecords] = useState({ count: 0, last30DaysCount: 0 })
  const [totalCardableMasterRecords, setTotalCardableMasterRecords] = useState({ count: 0, last30DaysCount: 0 })
  const [topCardableTableData, setTopCardableTableData] = useState([])
  const [topSupOpportunitiesTableData, setTopSupOpportunitiesTableData] = useState([])
  const [topOpportunitiesNoAcceptanceTableData, setTopOpportunitiesNoAcceptanceTableData] = useState([])
  const [isLoadingChildCount, setIsLoadingChildCount] = useState(true)
  const [isLoadingMasterCount, setIsLoadingMasterCount] = useState(true)
  const [isLoadingGlobalAcceptingCount, setIsLoadingGlobalAcceptingCount] = useState(true)
  const [isLoadingUnassignedChildCount, setIsLoadingUnassignedChildCount] = useState(true)
  const [isLoadingSuppliersInQaCount, setIsLoadingSuppliersInQaCount] = useState(true)
  const [isLoadingSuppliersWithoutCardAccCount, setIsLoadingSuppliersWithoutCardAccCount] = useState(true)
  const [isLoadingCardableMastersCount, setIsLoadingCardableMastersCount] = useState(true)
  const [isLoadingTopCardableTableData, setIsLoadingTopCardableTableData] = useState(true)
  const [isLoadingTopOpportunitiesUnknownAcc, setIsLoadingTopOpportunitiesUnknownAcc] = useState(true)
  const [isLoadingTopOpportunitiesNoAcceptance, setIsLoadingTopOpportunitiesNoAcceptance] = useState(true)
  const [isLoadingGraphData, setIsLoadingGraphData] = useState(true)
  const [graphState, setGraphState] = useState(state)
  const [last30DaysTotalSuppliers, setLast30DaysTotalSuppliers] = useState(0)
  const [totalSuppliersInSequenceRecords, setTotalSuppliersInSequenceRecords] = useState({ count: 0, last30DaysCount: 0 })
  const [isLoadingSupplierInSequence, setIsLoadingSupplierInSequence] = useState(true)

  useEffect(() => {
    const fetchAllData = async () => {
      // try {
      //   dispatch(getRecentlyViewedSearchData());
      //   dispatch(getRecentKeywords());

      //   const childCount = await dispatch(getChildSuppliersCount());
      //   setTotalChildRecords(childCount);
      //   setIsLoadingChildCount(false);
      // } catch {
      //   setIsLoadingChildCount(false);
      // }

      // try {
      //   const masterCount = await dispatch(getMasterSuppliersCount());
      //   setTotalMasterRecords(masterCount);
      //   setIsLoadingMasterCount(false);
      // } catch {
      //   setIsLoadingMasterCount(false);
      // }

      // try {
      //   const globalAcceptingCount = await dispatch(getGlobalAcceptingSuppliersCount());
      //   setTotalGlobalAcceptingSuppliers(globalAcceptingCount);
      //   setIsLoadingGlobalAcceptingCount(false);
      // } catch {
      //   setIsLoadingGlobalAcceptingCount(false);
      // }

      // try {
      //   const unassignedChildCount = await dispatch(getUnassignedChildSuppliersCount());
      //   setTotalUnassignedChildRecords(unassignedChildCount);
      //   setIsLoadingUnassignedChildCount(false);
      // } catch {
      //   setIsLoadingUnassignedChildCount(false);
      // }

      // try {
      //   const suppliersInQa = await dispatch(getSuppliersInQaCount());
      //   setTotalSuppliersInQaRecords(suppliersInQa);
      //   setIsLoadingSuppliersInQaCount(false);
      // } catch {
      //   setIsLoadingSuppliersInQaCount(false);
      // }

      // try {
      //   const cardableMasters = await dispatch(getCardableMastersCount());
      //   setTotalCardableMasterRecords(cardableMasters);
      //   setIsLoadingCardableMastersCount(false);
      // } catch {
      //   setIsLoadingCardableMastersCount(false);
      // }

      // try {
      //   const suppliersWithoutCardAcc = await dispatch(getSuppliersWithoutCardAcceptanceCount());
      //   setTotalSuppliersWithoutCardAccRecords(suppliersWithoutCardAcc);
      //   setIsLoadingSuppliersWithoutCardAccCount(false);
      // } catch {
      //   setIsLoadingSuppliersWithoutCardAccCount(false);
      // }

      // try {
      //   const suppliersInSequence = await dispatch(getSuppliersInSequenceCount());
      //   setTotalSuppliersInSequenceRecords(suppliersInSequence);
      //   setIsLoadingSupplierInSequence(false);
      // } catch {
      //   setIsLoadingSupplierInSequence(false);
      // }
      
        setIsLoadingChildCount(false);
        setIsLoadingMasterCount(false);
        setIsLoadingGlobalAcceptingCount(false);
        setIsLoadingUnassignedChildCount(false);
        setIsLoadingSuppliersInQaCount(false);
        setIsLoadingCardableMastersCount(false);
        setIsLoadingSuppliersWithoutCardAccCount(false);
        setIsLoadingSupplierInSequence(false);

      try {
        // const topCardable = await dispatch(getTopCardableSuppliers());
        const topCardable = {};
        const tmpSuppliers = topCardable?.suppliers?.map(sup => {
          const childCount = topCardable?.childCount.find(child => sup?.masterId === child?.masterId);
          const supName = topCardable?.masterSupNames.find(masterSup => sup?.masterId === masterSup?.id);
          return {
            ...sup,
            totalsuppliers: parseInt(childCount?.count),
            suppliername: supName?.suppliername
          };
        }) || [];
        setTopCardableTableData(tmpSuppliers);
        setIsLoadingTopCardableTableData(false);
      } catch {
        setIsLoadingTopCardableTableData(false);
      }

      try {
        // const topUnknownAcc = await dispatch(getTopOpportunitiesWithUnknownAcceptance());
        const topUnknownAcc = {}
        let tmpSuppliers = topUnknownAcc?.suppliers?.map(sup => {
          const childCount = topUnknownAcc?.childCount.find(child => sup?.masterId === child?.masterId);
          const supName = topUnknownAcc?.masterSupNames.find(masterSup => sup?.masterId === masterSup?.id);
          return {
            ...sup,
            totalsuppliers: parseInt(childCount?.count),
            suppliername: supName?.suppliername
          };
        }) || [];
        tmpSuppliers.sort((a, b) => b.potentialcv - a.potentialcv);
        setTopSupOpportunitiesTableData(tmpSuppliers);
        setIsLoadingTopOpportunitiesUnknownAcc(false);
      } catch {
        setIsLoadingTopOpportunitiesUnknownAcc(false);
      }

      try {
        // const topNoAcc = await dispatch(getTopOpportunitiesWithNoAcceptance());
        const topNoAcc = {};
        let tmpSuppliers = topNoAcc?.suppliers?.map(sup => {
          const childCount = topNoAcc?.childCount.find(child => sup?.masterId === child?.masterId);
          const supName = topNoAcc?.masterSupNames.find(masterSup => sup?.masterId === masterSup?.id);
          return {
            ...sup,
            totalsuppliers: parseInt(childCount?.count),
            suppliername: supName?.suppliername
          };
        }) || [];
        tmpSuppliers.sort((a, b) => b.potentialcv - a.potentialcv);
        setTopOpportunitiesNoAcceptanceTableData(tmpSuppliers);
        setIsLoadingTopOpportunitiesNoAcceptance(false);
      } catch {
        setIsLoadingTopOpportunitiesNoAcceptance(false);
      }

      try {
        // const suppliersPerUser = await dispatch(getSuppliersAddedByPerUser(domainUserIds));
        const suppliersPerUser = {}
        const tmpData = [];
        const labels = [];
        let total = 0;
        let tmpState = { ...graphState };
        domainUsers.forEach(domainUser => {
          const hasUser = suppliersPerUser.find(user => user?.userId === domainUser?.userId);
          if (hasUser) {
            tmpData.push(parseInt(hasUser?.count));
            total += parseInt(hasUser?.count);
            labels.push(domainUser?.user?.firstname + (domainUser?.user?.lastname ? ' ' + domainUser?.user?.lastname : ''));
          }
        });
        tmpState['datasets'][0]['data'] = tmpData;
        tmpState['labels'] = labels;
        setGraphState(tmpState);
        setLast30DaysTotalSuppliers(total);
        setIsLoadingGraphData(false);
      } catch {
        setIsLoadingGraphData(false);
      }
    };

    fetchAllData();
  }, [dispatch]);


  const headerElements = () => {
    return tableColumns.map((h, index) => {
      return (
        <Column
          resizable
          key={h.name}
          width={150}
        >
          <HeaderCell><h4 className='mb-0 fw-bold text-black d-inline'>{h.label}</h4></HeaderCell>
          {(index === 0 || index === 1) ?
            <LinkCell dataKey={h.name} />
            :
            <Cell className='text-black' dataKey={h.name} />
          }
        </Column>
      )
    })
  }

  useEffect(() => {
    getNewUnreadNotification()
  }, [])

  return (
    <div className='dashboard-component mt-4 mb-4'>
      <div className='current-page-title'>
        {currentPageName}
      </div>
      <div className='dashboard-header d-flex flex-column gap-3 gap-xl-5'>
        <div className='row gap-3 gap-xl-5 g-0'>
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>MASTER SUPPLIERS</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>MASTER SUPPLIERS</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>MASTER SUPPLIERS</h4>
              }
              {isLoadingMasterCount ? <LoaderComponent /> :
                <>
                  <span>{totalMasterRecords?.count ? Number(totalMasterRecords?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalMasterRecords?.last30DaysCount ? Number(totalMasterRecords?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>CHILD SUPPLIERS</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>CHILD SUPPLIERS</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>CHILD SUPPLIERS</h4>
              }
              {isLoadingChildCount ? <LoaderComponent /> :
                <>
                  <span>{totalChildRecords?.count ? Number(totalChildRecords?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalChildRecords?.last30DaysCount ? Number(totalChildRecords?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>GLOBAL ACCEPTING SUPPLIERS</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>GLOBAL ACCEPTING SUPPLIERS</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>GLOBAL ACCEPTING SUPPLIERS</h4>
              }
              {isLoadingGlobalAcceptingCount ? <LoaderComponent /> :
                <>
                  <span>{totalGlobalAcceptingSuppliers?.count ? Number(totalGlobalAcceptingSuppliers?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalGlobalAcceptingSuppliers?.last30DaysCount ? Number(totalGlobalAcceptingSuppliers?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>SUPPLIERS IN SEQUENCE</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>SUPPLIERS IN SEQUENCE</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>SUPPLIERS IN SEQUENCE</h4>
              }
              {isLoadingSupplierInSequence ? <LoaderComponent /> :
                <>
                  <span>{totalSuppliersInSequenceRecords?.count ? Number(totalSuppliersInSequenceRecords?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalSuppliersInSequenceRecords?.last30DaysCount ? Number(totalSuppliersInSequenceRecords?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
        </div>

        <div className='row gap-3 gap-xl-5 g-0'>
          {/* <div className='row gap-3 gap-xl-5 g-0 tiles-row flex-no-wrap'> */}
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>WITHOUT CARD ACCEPTANCE</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>WITHOUT CARD ACCEPTANCE</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>WITHOUT CARD ACCEPTANCE</h4>
              }
              {isLoadingSuppliersWithoutCardAccCount ? <LoaderComponent /> :
                <>
                  <span>{totalSuppliersWithoutCardAccRecords?.count ? Number(totalSuppliersWithoutCardAccRecords?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalSuppliersWithoutCardAccRecords?.last30DaysCount ? Number(totalSuppliersWithoutCardAccRecords?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>SUPPLIERS IN QA</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>SUPPLIERS IN QA</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>SUPPLIERS IN QA</h4>
              }
              {isLoadingSuppliersInQaCount ? <LoaderComponent /> :
                <>
                  <span>{totalSuppliersInQaRecords?.count ? Number(totalSuppliersInQaRecords?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalSuppliersInQaRecords?.last30DaysCount ? Number(totalSuppliersInQaRecords?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>CARDABLE MASTERS</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>CARDABLE MASTERS</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>CARDABLE MASTERS</h4>
              }
              {isLoadingCardableMastersCount ? <LoaderComponent /> :
                <>
                  <span>{totalCardableMasterRecords?.count ? Number(totalCardableMasterRecords?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalCardableMasterRecords?.last30DaysCount ? Number(totalCardableMasterRecords?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
          <div className='flex-one col-3 dashboard-card p-4'>
            <div className='card-left align-items-center flex-grow-1 text-white gap-2 h-100'>
              {window.innerWidth >= 1400 ?
                <h2 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>UNASSIGNED CHILDREN</h2>
                :
                (window.innerWidth > 991 && window.innerWidth < 1400) ?
                  <h3 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>UNASSIGNED CHILDREN</h3>
                  :
                  <h4 className='fw-bold mb-0 text-md-center text-lg-start align-self-start mb-auto'>UNASSIGNED CHILDREN</h4>
              }
              {isLoadingUnassignedChildCount ? <LoaderComponent /> :
                <>
                  <span>{totalUnassignedChildRecords?.count ? Number(totalUnassignedChildRecords?.count).toLocaleString() : 0}</span>
                  <h4 className='text-white text-end mb-0 align-self-end'>Last 30 days - {totalUnassignedChildRecords?.last30DaysCount ? Number(totalUnassignedChildRecords?.last30DaysCount).toLocaleString() : 0}</h4>
                </>
              }
            </div>
          </div>
          <div className='w-100 dashboard-content d-flex flex-column gap-5'>
            <div className='row w-100'>
              <div className='col-9'>
                <div className='w-100 top-cardable-table'>
                  <div className='dashboard-content-list-header flex'>
                    <h1 className='text-black mb-0 fw-bold dashboard-content-list-header-left'>
                      Top Cardable Suppliers
                    </h1>
                  </div>
                  <div className='border border-2 rounded mt-4 bg-white position-relative'>
                    {isLoadingTopCardableTableData && <LoaderComponent />}
                    <Table
                      rowClassName='ps-3 pe-3'
                      virtualized
                      autoHeight
                      data={topCardableTableData}
                    >
                      {headerElements()}
                    </Table>
                  </div>
                </div>
              </div>
              <div className='col-3 mt-4 p-5 px-0'>
                <div className='flex-one w-100 border border-1 rounded'>
                  <div className={`w-100 pl-3 dashboard-content-graph position-relative${isLoadingGraphData ? ' h-25' : ''}`}>
                    <h1 className='fw-bold text-black m-3 mb-0'>
                      Top Ricochets
                    </h1>
                    {isLoadingGraphData ? <LoaderComponent />
                      :
                      <div className='m-3 mt-1'>
                        <h4 className='text-blue'> Last 30 days! - {last30DaysTotalSuppliers}</h4>
                        <Doughnut className='mt-5 pt-4'
                          data={graphState}
                          options={{
                            plugins: {
                              legend: {
                                display: true,
                                labels: {
                                  color: '#000000',
                                  boxWidth: 10
                                },
                                position: 'bottom'
                              },
                            }
                          }}
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            {/* <div className='w-100 top-cardable-table'>
                <div className='dashboard-content-list-header flex'>
                  <h1 className='text-black mb-0 fw-bold dashboard-content-list-header-left'>
                    Top Cardable Suppliers
                  </h1>
                </div>
                <div className='border border-2 rounded mt-4 bg-white position-relative'>
                  {isLoadingTopCardableTableData && <LoaderComponent />}
                  <Table
                    rowClassName='ps-3 pe-3'
                    virtualized
                    autoHeight
                    data={topCardableTableData}
                  >
                    {headerElements()}
                  </Table>
                </div>
              </div> */}

            <div className='w-100 top-opportunities-unknown-acc-table'>
              <div className='dashboard-content-list-header flex'>
                <h1 className='text-black mb-0 fw-bold dashboard-content-list-header-left'>
                  Top Opportunity - Unknown Acceptance
                </h1>
              </div>
              <div className='border border-2 rounded mt-4 bg-white position-relative'>
                {isLoadingTopOpportunitiesUnknownAcc && <LoaderComponent />}
                <Table
                  rowClassName='ps-3 pe-3'
                  virtualized
                  autoHeight
                  data={topSupOpportunitiesTableData}
                >
                  {headerElements()}
                </Table>
              </div>
            </div>
            <div className='w-100 most-ricochets-table'>
              <div className='dashboard-content-list-header flex'>
                <h1 className='text-black mb-0 fw-bold dashboard-content-list-header-left'>
                  Top Opportunity - Doesn't Accept Card
                </h1>
              </div>
              <div className='border border-2 rounded mt-4 bg-white position-relative'>
                {isLoadingTopOpportunitiesNoAcceptance && <LoaderComponent />}
                <Table
                  rowClassName='ps-3 pe-3'
                  virtualized
                  autoHeight
                  data={topOpportunitiesNoAcceptanceTableData}
                >
                  {headerElements()}
                </Table>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div >
  )
}

export default DashboardComponent
